import Vue from 'vue';
import array from 'lodash/array';
import axios from 'axios';
import qs from 'qs';
import InputField from '../../general/elements/inputfield';
import OutsourcersFilter from '../readeableids/outsourcersfilter';

export default Vue.component('resourcestock', {
    components:{
        'inputfield': InputField,
        'outsourcersfilter': OutsourcersFilter
    },
    template:`
    <tbody>
        <tr>
            <td class="text-center">
                <div :id="'img-' + resource.code" style="display: none;">
                    <img :src='resourceImage' width='150'/>
                </div>
                <i v-if="resourceImage" class="si si-camera js-popover" data-html="true" :data-tooltip-element="'#img-' + resource.code"></i>
            </td>
            <td>{{resource.code}}</td>
            <td>{{resource.name}}</td>
            <td>{{fractionsList.join(', ')}}</td>
            <td class="text-center" v-if="permissions.canEdit">
                <input class="form-control" type="number" :value="resource.amount" @input="updateStock" oninput="validity.valid || (value='')" :min="0" :disabled="disabledInputs" />
            </td>
            <td class="text-center" v-if="!permissions.canEdit">
                <span>{{resource.amount}}</span>
            </td>
            <td class="text-center">{{resource.forecastAmount}}</td>
            <td v-if="permissions.canEdit">
                <outsourcersfilter v-model="resource.outsourcer.id" prefix="SP" v-bind:isFormField="false"
                    :text.sync="resource.outsourcer.code" :description.sync="resource.outsourcer.name" :readonly="disabledInputs" />
            </td>
            <td v-if="!permissions.canEdit">
                <span>{{resource.outsourcer.name}}</span>
            </td>
            <td v-if="permissions.canEdit">
                <button class="btn btn-sm btn-dual" type="button" v-on:click="editCollectionResource(resource, $event)">
                    <i class="si si-pencil"></i>
                </button>
            </td>
        </tr>
    </tbody>
    `,
    data: function(){
        return {
            axe: axios.create({
                baseURL: '/webapi/servicepointstock',
                paramsSerializer: function(params) {
                    return qs.stringify(params, { indices: false, allowDots: true, skipNulls: true })
                }
            }),
            disabledInputs: this.readonly
        }
    },
    props:{
        resource: Object,
        resourceImage: String,
        readonly: { type: Boolean, default: true },
        permissions: Object
    },
    computed: {
        fractionsList(){
            return array.uniq(this.resource.fractions.map(x => x.code));
        }
    },
    methods: {
        editCollectionResource(resource, event){
            event.stopPropagation();
            this.disabledInputs = !this.disabledInputs;
        },
        updateStock: _.debounce(function(e) {
            const oldAmount = this.resource.amount,
            newAmount = e.target.value,
            changedAmount = newAmount - oldAmount;

            this.validateStockUpdate(newAmount, response => {
                if (response && response.data) {
                    this.resource.forecastAmount += changedAmount;
                    this.resource.amount = newAmount;
                } else {
                    this.resource.amount = oldAmount;
                }
                this.$forceUpdate();
            }); 
        }, 300),
        validateStockUpdate(amount, callback) {
            let resource = Object.assign({}, this.resource);
            resource.amount = amount;

            return this.axe.get('/IsStockUpdateValid', { params: { request: { servicePointId: this.$root.servicePointId, resource: resource }}})
            .then((response) => { callback(response); })
            .catch((error) => { console.log('Error validating stock update: ' + error);  });
        }
    }
});